<template>
  <b-container>
    <b-alert v-if="successMsg" variant="success" show dismissible>
      {{ successMsg }}
    </b-alert>
    <b-alert v-if="errorMsg" variant="danger" show dismissible>
      {{ errorMsg }}
    </b-alert>
    <b-row class="align-items-center">
      <b-col>
        <h1>Canned Note</h1>
      </b-col>
      <b-col>
        <b-button class="float-right" href="/admin/canned-notes">Back</b-button>
      </b-col>
    </b-row>
    <hr />    
    <b-form-group label="Title" class="font-weight-bold" label-for="name" :class="{
      'text-danger': validation.hasError('name'),
    }">
      <b-form-input id="name" v-model="name" maxlength="128"></b-form-input>
      <span class="error-message">{{
      validation.firstError("name")
    }}</span>
    </b-form-group>
    <b-form-group label="Status" class="font-weight-bold" label-for="status" :class="{
        'text-danger': validation.hasError('set_active'),
      }">
      <b-form-select v-model="set_active" id="set_active" :options="set_active_codes"></b-form-select>
    </b-form-group>
    <b-form-group class="font-weight-bold" label-for="details"
      :class="{ 'text-danger': validation.hasError('details'), }">
      <b-form-textarea rows="5" id="details" v-model="details">
      </b-form-textarea>
      <span class="error-message">{{ validation.firstError("details") }}</span>
    </b-form-group>
    <b-alert variant="danger" :show="validation.errors.length > 0">
      There are missing required fields</b-alert>
    <b-button variant="primary" v-if="validation.errors.length === 0" @click="saveCanned">Save Canned Message</b-button>
  </b-container>
</template>

<script>
import NoteDataService from "@/services/NoteDataService";
import SimpleVueValidation from "simple-vue-validator";
const Validator = SimpleVueValidation.Validator;

export default {
  data() {
    return {
      name: "",
      set_active: 1,
      category: "policies",
      details: "",
      id: null,
      action: "create",
      successMsg: null,
      errorMsg: null,
      errors: []
    };
  },

  validators: {
    'name': function (value) {

      return Validator.value(value).required("Name is required");
    },
    'details': function (value) {

      // length less than 1024

      if (value.length >= 1024) {
        return Validator.value(value).required("Details are too long.");
      }

      return Validator.value(value).required("Details are required");

    }
  },

  created() {
    if (this.$route.params.id !== undefined) {
      NoteDataService.getCannedById(this.$route.params.id).then((res) => {

        this.name = res.data.name.trim();
        this.set_active = res.data.set_active;
        this.details = res.data.details.trim();
        this.id = this.$route.params.id;
        this.action = "update";
      }).catch(() => {
        this.errorMsg = "Failed to load canned note.";
      });
    }

    this.set_active_codes = NoteDataService.set_active_codes().map((obj) => ({
      value: obj.id,
      text: obj.label,
    }));
  },
  methods: {
    async updateNote() {

      const updateData = {
        name: this.name,
        set_active: this.set_active,
        details: this.details
      }

      const result = await NoteDataService.updateCanned(this.id, updateData);
      if (result && result.status >= 400) {
        this.errorMsg = "Failed to save canned note. Please try again.";
      } else {
        this.successMsg = "Canned note updated successfully";
      }
    },

    async createNote() {
      const result = await NoteDataService.createCanned({
        name: this.name,
        set_active: this.set_active,
        details: this.details,
        category: 'policies'
      });
      if (result && result.status >= 400) {
        this.errorMsg = "Failed to create canned note. Please try again.";
      } else {
        this.successMsg = "Canned note created successfully";
      }
    },
    async saveCanned() {
      this.$validate().then(success => {
        if (!success) {
          return;
        }
        if (this.action === "update") {

          this.updateNote();

        } else {

          this.createNote();

        }

      })
    },
  },
  watch: {
    name: function () {
      this.$validate();
    },
    details: function () {
      this.$validate();
    },
  },
};
</script>
